var _path, _path2, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.021c6.904 0 12.5 5.597 12.5 12.5 0 6.904-5.596 12.5-12.5 12.5H1v-12.5c0-6.903 5.596-12.5 12.5-12.5z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.021c6.904 0 12.5 5.597 12.5 12.5 0 6.904-5.596 12.5-12.5 12.5H1v-12.5c0-6.903 5.596-12.5 12.5-12.5z",
    stroke: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.925,
    y: 5.949,
    width: 15.147,
    height: 15.147,
    rx: 7.573,
    fill: "#080808",
    stroke: "#080808",
    strokeWidth: 0.448
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#comment-pin_svg__clip0_2305_65558)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.867 11.31c0-.612.497-1.11 1.11-1.11h5.045c.613 0 1.11.498 1.11 1.11v3.835a1.11 1.11 0 01-1.11 1.11h-1.21a.504.504 0 00-.404.201l-.666.888a.303.303 0 01-.485 0l-.666-.888a.504.504 0 00-.403-.201h-1.211a1.11 1.11 0 01-1.11-1.11V11.31z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "comment-pin_svg__clip0_2305_65558"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9.464 9.799)",
    d: "M0 0h8.072v8.072H0z"
  })))));
}
export default SvgCommentPin;